import { selectCurrentPageEntities } from '@ngneat/elf-pagination';
import { createRequestDataSource } from '@ngneat/elf-requests';

import { auditsStore } from './audits.store';

export const getAuditsDataSource = createRequestDataSource({
  store: auditsStore,
  data$: () => auditsStore.pipe(selectCurrentPageEntities()),
  requestKey: 'getAudits',
  dataKey: 'audits',
});

